<div class="bg" *ngIf="hide_small"></div>

<header id="header" [ngClass]="{'hideBG': hide_small}" class="d-flex justify-content-center align-items-center flex-column">
  <div *ngIf="!hide_small">
    <div class="wave bottom">
      <img src="../../assets/img/background/waves/Vector-3.svg" alt="Achtergrond golf effect voor onderkant hero foto">
    </div>
    <div class="wave bottom">
      <img src="../../assets/img/background/waves/Vector.webp" alt="Achtergrond golf effect voor onderkant hero foto">
    </div>
    <div class="wave top">
      <img src="../../assets/img/background/waves/Vector.svg" alt="Achtergrond golf effect voor bovenkant hero foto">
    </div>
    <div class="wave top">
      <img src="../../assets/img/background/waves/Vector.webp" alt="Achtergrond golf effect voor bovenkant hero foto">
    </div>
  </div>
  <div class="header_numbers" *ngIf="!hide_small">
    <div class="number">
      <h2 [countTo]="activity_number" [from]="0" [duration]="1.2">0</h2>
      <p>Activiteiten</p>
    </div>
    <div class="number">
      <h2 [countTo]="location_number" [from]="0" [duration]="1.2">0</h2>
      <p>Locaties</p>
    </div>
    <div class="number">
      <h2 [countTo]="participant_number" [from]="0" [duration]="1.2">0</h2>
      <p>Deelnemers</p>
    </div>
  </div>
  <div class="searchbar">
    <input type="text" placeholder="Zoek een activiteit..." class="search_activity" [(ngModel)]="searchTerm">
    <!--<input type="text" placeholder="Plaats of postcode..." class="search_location" *ngIf="!hide_medium">-->
    <button (click)="searchActivities()">Zoeken <i class="bi bi-arrow-right"></i></button>
  </div>
</header>

<main id="main">
  <div class="activity_holder">
    <a *ngFor="let category of categories" class="activity"  [routerLink]="['/activiteiten']" [queryParams]="{type: category.tag}">
      <img src="assets/img/icons/{{ category.tag }}.svg" alt="{{ category.name }} icoontje" height="55" width="55">
      <p>{{ category.name }}</p>
    </a>
  </div>
  <h2>Bij jou in de buurt</h2>
  <div class="cardView">
    <div class="spacing d-grid grid cardsHolder" *ngIf="!loadingEvents; else placeHolder">
      <app-event-card *ngFor='let event of events' [event]="event" [border]="true"></app-event-card>
    </div>
    <ng-template #placeHolder>
      <div class="spacing d-grid grid cardsHolder">
        <app-event-card-placeholder [border]="true" *ngFor="let _ of [].constructor(4)"></app-event-card-placeholder>
      </div>
    </ng-template>
    <div class="spacing d-flex justify-content-center mt-4">
      <button href="#" class="more_button" [routerLink]="['/activiteiten']">Meer activiteiten <i
        class="bi bi-arrow-right"></i></button>
    </div>
  </div>
</main>


